import { EventMembersList } from "./EventMembersList";

export default EventMembersList;
